<template>
  <div>
    <Masthead :report_type="report.origin" :title="title"/>
    <C3Cover :report="report"/>
    <C3ScheduleL v-if="reportDisplay('loans')" :report="report"/>
    <C3ScheduleAU v-if="reportDisplay('scheduleAU')" :report="report"/>
    <C3MiscReceipts v-if="reportDisplay('miscReceipts')" :report="report"/>
    <report-attachments v-if="reportDisplay('attachments')" :report="report"/>
  </div>
</template>

<script>
import Masthead from "./Masthead";
import C3ScheduleAU from "./C3ScheduleAU";
import C3Cover from "./C3Cover";
import C3ScheduleL from "./C3ScheduleL";
import C3MiscReceipts from "./C3MiscReceipts";
import ReportAttachments from "./ReportAttachments";
import filters from "../filters";
import utils from "./report-utils";

export default {
  name: "C3",
  data() {
    return {
      title: 'CASH RECEIPTS MONETARY CONTRIBUTIONS'
    }
  },
  components: {ReportAttachments, C3Cover, C3ScheduleL, Masthead, C3ScheduleAU, C3MiscReceipts},
  props: {
    report: {
      type: Object,
      default: function () {
        return {origin: "none"}
      }
    }
  },
  methods: {
    ...filters.filters, ...utils,
    reportDisplay(report) {
      switch (report) {
        case 'scheduleAU':
          if (this.arrayHasItems(this.report.user_data.auctions)) {
            return true;
          }
          break;
        case 'loans':
          if (this.arrayHasItems(this.report.user_data.loans)) {
            return true;
          }
          break;
        case 'miscReceipts':
          if (this.arrayHasItems(this.report.user_data.misc)) {
            return true;
          }
          break;
        case 'attachments':
          if (this.arrayHasItems(this.report.user_data.attachments)) {
            return true;
          }
          if (this.arrayHasItems(this.report.attachments)) {
            return true;
          }
          break;
      }
    }
  }
}
</script>

<style scoped>

</style>